import OfficeJobDetailHeader from './OfficeJobDetailHeader';

export default OfficeJobDetailHeader;
